import { getWindow } from 'utilities/window.js';
import { MetaDataRaw } from './set-tags.js';

/** Remove previously generated header elements */
export const clearPreviousTags = (pageMetadata?: MetaDataRaw): void => {
  const lclWindow = getWindow();

  const head = lclWindow?.document.head;

  const hasCanonical = head?.querySelector(`[rel='canonical']`);
  if (hasCanonical) {
    hasCanonical.remove();
  }
  /** Identify any items on head that are not on
   * View all meta tags, exlude those on index
   * Delete all meta tags that are not on index
   */
  if (pageMetadata) {
    Object.keys(pageMetadata).forEach((key) => {
      const item = pageMetadata[key];
      if ('name' in item) {
        const hasMatch = head?.querySelector(`[name='${key}']`);
        if (hasMatch) {
          hasMatch.remove();
        }
      } else if ('property' in item) {
        const hasMatch = head?.querySelector(`[property='${key}']`);
        if (hasMatch) {
          hasMatch.remove();
        }
      }
    });
  }
};

export const setHeaderLinkEls = (pageMetadata: { [key: string]: string }): void => {
  const lclWindow = getWindow();

  if (pageMetadata['canonicalUrl'] && lclWindow) {
    const { document } = lclWindow;
    const headerEl = document.createElement('link');
    headerEl.setAttribute('rel', 'canonical');
    headerEl.setAttribute('href', pageMetadata['canonicalUrl']);
    document.head.appendChild(headerEl);
  }
};

export const setHeaderMetaEls = (pageMetadata: MetaDataRaw): void => {
  const lclWindow = getWindow();
  if (lclWindow) {
    const { document } = lclWindow;
    Object.keys(pageMetadata).map((key) => {
      const value = pageMetadata[key];
      if (value?.content) {
        const headerEl = document.createElement('meta');
        if ('name' in value) {
          headerEl.setAttribute('name', value.name);
          headerEl.setAttribute('content', value.content);
        } else if ('property' in value) {
          headerEl.setAttribute('property', value.property);
          headerEl.setAttribute('content', value.content);
        } else {
          return undefined;
        }
        document.head.appendChild(headerEl);
      }
    });
  }
};
